import axios from 'axios';

export default {
  async fetchRolePermissions() {
    const { data } = await axios.get(`${process.env.VUE_APP_MON_COMPTE_BACKEND_URL}/permissions`);
    const permissions = data.data;
    console.log('permissions', permissions);
    return permissions;
  },
};
